// extracted by mini-css-extract-plugin
export default {"segmented":"GenericSegmented_segmented__upBAp"};